import React from 'react';

const ListingStats = ({listing}) => {
    return (
        <div>
            <div className="text-base" style={{color: '#6A6A6A', marginBottom: '4px'}}>
                30 Day Summary
            </div>
            <div style={{display: 'flex', gridGap: '24px'}}>
                <div>
                    <div className="text-lg">
                        {typeof listing.clicks === 'number' ? listing.clicks : 'N/A'}
                    </div>
                    <div className="text-lg">Clicks</div>
                </div>
                <div>
                    <div className="text-lg">
                        {typeof listing.calls === 'number' ? listing.calls : 'N/A'}
                    </div>
                    <div className="text-lg">Calls</div>
                </div>
            </div>
        </div>
    );
};

export default ListingStats;
